export class ExamPayment {
    personId: number;
    totalCost: number;
    applicationId: number;
    specialAccomodations: boolean;
    internationalTesting: boolean;
    details: ExamPaymentDetail[] = [];
    paymentType: string;
    cardNumber: string;
    expirationDate: string;
    cardCode: string;
    voucher: string;
    payerName: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    countryId: string;
    accountNumber: string;
    routingNumber: string;
    accountType: string;
    nameOnAccount: string;
    dataDescriptor = null;
    dataValue = null;
}

export class ExamPaymentDetail {
    serviceCodeID: number;
    quantity: number;
    cost: number;
}
